import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresListaRemuneradosEditar', {
    template: template,
    controller: NominasNominaColaboradoresListaRemuneradosEditarComponent,
    bindings: {
      idNomina: '<',
      idProyecto: '<',
      idColaborador: '<',
      data: '<',
      // Estatus
      calculado: '<',
      editable: '<',
      // Eventos
      onChange: '&',
      onClose: '&',
    },
  })

function NominasNominaColaboradoresListaRemuneradosEditarComponent($catalogos, $q, NominasNominaColaboradoresColaborador) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar
  $ctrl.cancelar = cancelar
  $ctrl.cerrar = cerrar

  function $onInit() {
    $ctrl.actualizando = false
    $ctrl.$promise = $q.all([
      NominasNominaColaboradoresColaborador.get($ctrl.idNomina, $ctrl.idProyecto, $ctrl.idColaborador)
        .then(function (response) {
          $ctrl.data = response.data
        }),

      $catalogos.get('movimientos')
        .then(function (data) {
          $ctrl.conceptos = data
        }),
    ])
  }

  function actualizar() {
    if (!$ctrl.editable)
      return

    $ctrl.actualizando = true

    return NominasNominaColaboradoresColaborador.put($ctrl.idNomina, $ctrl.idProyecto, $ctrl.idColaborador, $ctrl.data)
      .then(function () {
        $ctrl.onChange({$event: {data: $ctrl.data}})
        cerrar($ctrl.data)
      })
      .finally(function () {
        $ctrl.actualizando = false
      })
  }

  function cancelar(pristine) {
    if (pristine)
      cerrar()
  }

  function cerrar(data) {
    $ctrl.onClose({$event: {data: data}})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/lista/remunerados/editar/component.js